module.exports = __webpack_public_path__ + "static/media/need-perscriptions.e655b8ff.jpg";